import 'flb-ui/dist/flb-ui.css'
import 'flb-ui/dist/docs.css'
import 'flb-ui'
import hljs from 'highlight.js'
import '../src/docs.sass'
import Rails from '@rails/ujs'

Rails.start()
hljs.initHighlightingOnLoad()
